import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxUser from "../../util/remote/ajaxUser";

const ProcessDisbursement=(props)=>{

    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState("")
    const [amount, setAmount] = useState("")

    const data = {
        vendor_user_id: props.accountID,
        secure_string: password,
        amount: amount     
    };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(password.length>0){
            setLoading(true)
            const server_response = await ajaxUser.processDisbursement(data);
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                setPassword("")
                props.g()
                props.h()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Enter custom password provided by the administrator!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                <button 
                    type="button" 
                    className={`btn-fill-md text-light bg-dodger-blue`} 
                    onClick={handleUpdate}>Process<i class="fas fa-check mg-l-15"></i>
                </button>
            </>
        }
    }

    return(
        <SystemModal
            title="Process Disbursement"
            id="model-process-disbursement"
            size="md"
            footer={RenderFooter}
        >
            <div className="row">
                <div className="mb-4 col-12 form-group">
                <label htmlFor="">Amount <span style={{color:"red"}}>*</span></label>
                <input onChange={(e)=>setAmount(e.target.value)} placeholder="Enter amount to disburse..." style={{border: "1px solid grey"}} value={amount} type="text" className="form-control"/>
                </div>
                <div className="mb-4 col-12 form-group">
                <label htmlFor="">Password <span style={{color:"red"}}>*</span></label>
                <input onChange={(e)=>setPassword(e.target.value)} required placeholder="Enter custom password provided by the administrator..." style={{border: "1px solid grey"}} value={password} type="password" className="form-control"/>
                </div>
            </div>
       
        </SystemModal>
    )
}

export default ProcessDisbursement
